import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const PcRawMaterials = React.lazy(() => import('./index'));
const PcRmTable = React.lazy(() => import('./pcRmTable'));
const PcRawMaterial = React.lazy(() => import('./pcRawMaterial'));
const PcRmDetail = React.lazy(() => import('./pcRmDetail'));
const AddNewPcRawMaterial = React.lazy(() => import('./addNewPcRawMaterial'));
const EditPcRawMaterial = React.lazy(() => import('./editPcRawMaterial'));

export const usePcRawMaterialRoutes = () => {
    return (
        <React.Fragment>
            <Route path="pcRawMaterial" element={<Suspense fallback={<div>منتظر باشید...</div>}><PcRawMaterials isEstimated={false} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PcRmTable isEstimated={false}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewPcRawMaterial isEstimated={false}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><PcRawMaterial isEstimated={false}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PcRmDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditPcRawMaterial /></Suspense> } />
                </Route>
            </Route>
            <Route path="pcRawMaterialEstimated" element={<Suspense fallback={<div>منتظر باشید...</div>}><PcRawMaterials isEstimated={true} /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PcRmTable isEstimated={true}/></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewPcRawMaterial isEstimated={true}/></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><PcRawMaterial isEstimated={true}/></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PcRmDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditPcRawMaterial /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}